document.addEventListener("DOMContentLoaded", function() {
  // Delivery date
  function getNextWeekdayDate(startDate, daysToAdd) {
    let date = new Date(startDate);
    let added = 0;
    while (added < daysToAdd) {
      date.setDate(date.getDate() + 1);
      const day = date.getDay();
      // dimanche (0)
      if (day !== 0) {
        added++;
      }
    }
    return date;
  }
  
  function formatDateFR(date) {
    return date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' });
  }
  
  let deliveryDateElem = document.getElementById('delivery-date');
  if (deliveryDateElem) {
    // Livraison estimée : +2 à +3 jours ouvrés (hors dimanche)
    // Si après 14h, le traitement commence le lendemain
    let d1 = Number(deliveryDateElem.dataset.d1);
    let d2 = Number(deliveryDateElem.dataset.d2);
    if (d1 == '') d1 = 2;
    if (d2 == '') d2 = d1;
    const now = new Date();
    const heure = now.getHours();
    const baseDate = (heure >= 14) ? new Date(now.setDate(now.getDate() + 1)) : now;
    const startDate = getNextWeekdayDate(baseDate, d1);
    const endDate = getNextWeekdayDate(baseDate, d2);
    if (d1 != d2) deliveryDateElem.innerText = `${formatDateFR(startDate)} - ${formatDateFR(endDate)}`;
    else deliveryDateElem.innerText = `${formatDateFR(startDate)}`;
  }

  // Submenu scroll
  document.querySelectorAll('.collection-toolbar .submenu').forEach((container) => {
    let isDragging = false;
    let startX = 0;
    let scrollLeft = 0;
  
    // Start drag
    const start = (x) => {
      isDragging = false;
      startX = x;
      scrollLeft = container.scrollLeft;
    };
  
    // Move
    const move = (x) => {
      const walk = (x - startX) * 1.5;
      if (Math.abs(walk) > 5) isDragging = true;
      container.scrollLeft = scrollLeft - walk;
    };
  
    // Mouse events
    container.addEventListener('mousedown', (e) => {
      if (e.button !== 0) return; // Only left click
      start(e.pageX);
      container.classList.add('dragging');
  
      const onMove = (e) => move(e.pageX);
      const onUp = () => {
        container.classList.remove('dragging');
        window.removeEventListener('mousemove', onMove);
        window.removeEventListener('mouseup', onUp);
      };
  
      window.addEventListener('mousemove', onMove);
      window.addEventListener('mouseup', onUp);
    });
  
    // Touch events
    container.addEventListener('touchstart', (e) => {
      start(e.touches[0].pageX);
    });
  
    container.addEventListener('touchmove', (e) => {
      move(e.touches[0].pageX);
    });
  
    // Prevent click if dragging
    container.addEventListener('click', (e) => {
      if (isDragging) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    });
  
    // Prevent text/image selection
    container.addEventListener('dragstart', (e) => e.preventDefault());
  });

  // Goto complementary
  var intervalGotoComplementaryLoop = 0;
  var intervalGotoComplementary = setInterval(function(){
    const btnGotoComplementary = document.querySelector('.goto-complementary');
    const targetGotoComplementary = document.querySelector('.shopify-section--related-products-v-complementary');
    if (btnGotoComplementary && targetGotoComplementary) {
      btnGotoComplementary.addEventListener('click', (e) => {
        e.preventDefault();
        const yOffset = -250; 
        const y = targetGotoComplementary.getBoundingClientRect().top + window.scrollY + yOffset;
        window.scrollTo({top: y, behavior: 'smooth'});
      });
      clearInterval(intervalGotoComplementary);
    }
    
    intervalGotoComplementaryLoop++;
    if (intervalGotoComplementaryLoop >= 20) clearInterval(intervalGotoComplementary);
  }, 200);
});

document.addEventListener("DOMContentLoaded", function() {
  // Wholesale
  function formatPrice(amount) {
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(amount);
  }
  
  function updateSubtotals(target) {
    let total = 0;
    target.querySelectorAll(".variant-qty").forEach(function(input) {
      const qty = parseInt(input.value) || 0;
      const row = input.closest(".line");
      const price = parseFloat(row.getAttribute("data-price")) || 0;
      const subtotal = qty * price;
      const subtotalEl = row.querySelector(".variant-subtotal");
      if (subtotalEl) row.querySelector(".variant-subtotal").innerText = formatPrice(subtotal);
      total += subtotal;
    });
    target.querySelector(".wholesale-total").innerText = formatPrice(total);
  }

  function updateButtonStates(input, minus, plus) {
    const value = parseInt(input.value, 10) || 0;
    const min = parseInt(input.getAttribute('min'), 10) || 0;
    const max = parseInt(input.getAttribute('max'), 10);
  
    minus.disabled = value <= min;
    plus.disabled = max ? value >= max : false;
  }

  InitWholesale();

  let targetNodeWholesale = '.shopify-section--main-collection, .shopify-section--related-products, .shopify-section--recently-viewed-products';
  document.querySelectorAll(targetNodeWholesale).forEach((i) => {
    if (i) {
      const observerWholesale = new MutationObserver((mutationsList, observer) => {
        for (const mutation of mutationsList) {
          if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
            observer.disconnect();
            InitWholesale();
            observer.observe(i, { childList: true, subtree: true });
            break;
          }
        }
      });
      observerWholesale.observe(i, { childList: true, subtree: true });
    }
  });

  function InitWholesale() {
    //console.log('InitWholesale');
    document.querySelectorAll('.wholesale-table:not(.ready) .quantity-selector').forEach(selector => {
      const input = selector.querySelector('.variant-qty');
      const minus = selector.querySelector('.qty-minus');
      const plus = selector.querySelector('.qty-plus');
  
      updateButtonStates(input, minus, plus);
  
      if (minus) {
        minus.addEventListener('click', () => {
          const current = parseInt(input.value, 10) || 0;
          const min = parseInt(input.getAttribute('min'), 10) || 0;
          if (current > min) input.value = current - 1;
          updateButtonStates(input, minus, plus);
          updateSubtotals(input.closest('.wholesale-table'));
        });
      }
  
      if (plus) {
        plus.addEventListener('click', () => {
          const current = parseInt(input.value, 10) || 0;
          const max = parseInt(input.getAttribute('max'), 10);
          if (!max || current < max) input.value = current + 1;
          updateButtonStates(input, minus, plus);
          updateSubtotals(input.closest('.wholesale-table'));
        });
      }
    });
    
    document.querySelectorAll(".wholesale-table:not(.ready) .variant-qty").forEach(function(input) {
      input.addEventListener("input", function(){
        const minus = this.parentElement.querySelector('.qty-minus');
        const plus = this.parentElement.querySelector('.qty-plus');
        const current = parseInt(input.value, 10) || 0;
        const max = parseInt(this.getAttribute('max'), 10);
        if (current > max) this.value = max;
        updateButtonStates(this, minus, plus);
        updateSubtotals(this.closest('.wholesale-table'));
      });
      updateSubtotals(input.closest('.wholesale-table'));
    });
  
    document.querySelectorAll(".wholesale-table:not(.ready) .wholesale-add-to-cart").forEach(function(btn) {
      btn.addEventListener("click", function() {
        const root = btn.closest('.wholesale-table');
        let itemsToAdd = [];
        root.querySelectorAll(".variant-qty").forEach(function(input) {
          const qty = parseInt(input.value) || 0;
          if (qty > 0) {
            const variantId = input.getAttribute("data-variant-id");
            itemsToAdd.push({ id: variantId, quantity: qty });
          }
        });
        
        if (itemsToAdd.length === 0) {
          alert("Sélectionnez au moins une quantité pour ajouter au panier.");
          return;
        }
        
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd })
        })
        .then(response => {
          if (!response.ok) {
            return response.json().then(error => {
              throw new Error(error.description || 'Erreur inconnue');
            });
          }
          return response.json();
        })
        .then(function(data) {
          document.dispatchEvent(new CustomEvent("cart:refresh"));
          document.querySelector('.header__cart-link a[aria-controls="cart-drawer"]').click();
        })
        .catch(function(error) {
          alert(error);
        });
      });
    });
    
    document.querySelectorAll(".wholesale-table:not(.ready)  .select-variant-b2b a").forEach(function(btn) {
      btn.addEventListener("click", function(e) {
        e.preventDefault();
        const root = this.closest('.wholesale-table');
        
        const allEl = root.querySelectorAll(".select-variant-b2b a, .select-form-b2b > div");
        allEl.forEach(function(el) {
          el.classList.remove('selected');
        });
  
        const id = this.dataset.variantId;
        const el = root.querySelector('.select-form-b2b > div[data-variant-id="' + id + '"]');
        el.classList.add('selected');
        
        this.classList.add('selected');
      });
    });

    document.querySelectorAll(".wholesale-table:not(.ready)").forEach(function(table) {
      table.classList.add("ready");
    });
  }
});